export default {"src":"/_next/static/media/close.68111602.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};